export class ScormApi {

	public data: any = {};

	constructor() {
	}

	public LMSInitialize(_parameter: any): string {
		console.log("LMSInitialize");
		console.log(_parameter);
		return "true";

	}

	public LMSFinish(_parameter: any): string {
		console.log("LMSFinish");
		console.log(_parameter);
		return "true";
	}

	public LMSGetValue = function (_varname: any) : string {
		console.log("LMSGetValue");
		console.log(_varname);
		return "";
	};

	public LMSSetValue(key: string, v: string) : string{
		console.log("LMSSetValue", key, v);
		this.data[key] = v; // TODO: somehow circumvent this warning
		// Object.assign(this.data, key, v); // <- this will garble the key
		return "true";
	}

	public LMSCommit(_varname: any) {
		console.log("LMSCommit");
		console.log(_varname);
		return "true";
	}

	public LMSGetLastError() {
		console.log("LMSGetLastError");
		console.log("LAST ERROR");
		return "0";
	}

	public LMSGetErrorString = function (_varname: any) {
		console.log("LMSGetErrorString");
		console.log(_varname);
		return "";
	}

	public LMSGetDiagnostic = function (_varname: any) {
		console.log("LMSGetDiagnostic");
		console.log(_varname);
		return "";
	}

}
